import React from "react";
import { Typography, Box } from "@mui/material";
import styles from "./OurExperience.module.css";
import VerifiedIcon from "@mui/icons-material/Verified";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import BuildIcon from "@mui/icons-material/Build";
import luminousLogo from "../../assets/IconsImages/Favicon.png"; // Replace with actual path

const stats = [
  {
    icon: <BuildIcon color="primary" fontSize="large" />,
    label: "Years of Experience",
    value: "30+",
  },
  {
    icon: <EmojiEventsIcon color="success" fontSize="large" />,
    label: "State Honor Rewards",
    value: "10+",
  },
  {
    icon: <VerifiedIcon color="action" fontSize="large" />,
    label: "",
    value: "Xen, JVVNL",
  },
  {
    icon: <LocationOnIcon color="error" fontSize="large" />,
    label: "Regional Coverage",
    value: "Pan-Rajasthan",
  },
];

const OurExperience = () => {
  return (
    <div className={styles.experienceSection}>
      <Typography variant="h4" align="center" className={styles.heading}>
        Our Experience
      </Typography>

      <div className={styles.statsWrapper}>
        <div className={styles.founderSection}>
          <img
            src="/assets/founder.jpg"
            alt="Founder"
            className={styles.founderImage}
          />
          <Typography variant="h6" className={styles.founderName}>
            Kailash Chand Gupta
          </Typography>
          <Typography variant="body2" className={styles.founderTitle}>
            Founder & Solar Expert
          </Typography>
          {/* <Typography variant="body2" className={styles.founderQuote}>
            “We’ve helped over  families switch to clean, affordable solar
            energy.”
          </Typography> */}
        </div>

        <div className={styles.statsRow}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.statCard}>
              <div className={styles.iconWrapper}>{stat.icon}</div>
              <Typography variant="h6" className={styles.statValue}>
                {stat.value}
              </Typography>
              <Typography variant="body2" className={styles.statLabel}>
                {stat.label}
              </Typography>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.bottomSection}>
        <img
          src={luminousLogo}
          alt="Luminous Partner Logo"
          className={styles.partnerLogo}
        />
        <Typography variant="body2" className={styles.quote}>
          “The installation process was smooth and professional. I’m saving 70%
          on electricity!” – Happy Customer
        </Typography>
      </div>
    </div>
  );
};

export default OurExperience;
